import { Component } from '@angular/core';
import { SkeletonBaseComponent } from 'components/skeleton/skeleton-base.component';

@Component({
    selector: '[fc-skeleton]',
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.less'],
    standalone: false
})
export class SkeletonComponent extends SkeletonBaseComponent {}
